module.exports = __webpack_public_path__ + "media/images/page/service_logo-seo-1720fd50aaa85d4ab12b572069b7c202.png";